import React from 'react'
import { Show, TextField, DateField } from '@refinedev/antd'
import { useShow, useOne } from '@refinedev/core'
import { Typography, Tag } from 'antd'
import type { Tables } from '@muaa/shared'

type Mentorship = Tables<'mentorships'>
type Profile = Tables<'profiles'>

const { Title } = Typography

export function MentorshipShow() {
  const { query } = useShow<Mentorship>()
  const isLoading = query.isLoading
  const record = query.data?.data

  const { query: profileQuery } = useOne<Profile>({
    resource: 'profiles',
    id: record?.user_id ?? '',
    meta: { idColumnName: 'user_id' },
    queryOptions: { enabled: !!record?.user_id },
  })

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Member</Title>
      <TextField value={profileQuery.data?.data?.name ?? record?.user_id ?? '—'} />

      <Title level={5}>Headline</Title>
      <TextField value={record?.headline ?? '—'} />

      <Title level={5}>Available</Title>
      {record != null ? (
        <Tag color={record.available ? 'green' : 'default'}>
          {record.available ? 'Yes' : 'No'}
        </Tag>
      ) : (
        <TextField value="—" />
      )}

      <Title level={5}>Created</Title>
      {record?.created_at ? (
        <DateField value={record.created_at} format="MMM D, YYYY h:mm A" />
      ) : (
        <TextField value="—" />
      )}
    </Show>
  )
}
